import { render, staticRenderFns } from "./ActivityStep.vue?vue&type=template&id=05127c6c&scoped=true"
import script from "./ActivityStep.vue?vue&type=script&lang=js"
export * from "./ActivityStep.vue?vue&type=script&lang=js"
import style0 from "./ActivityStep.vue?vue&type=style&index=0&id=05127c6c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05127c6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1708/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05127c6c')) {
      api.createRecord('05127c6c', component.options)
    } else {
      api.reload('05127c6c', component.options)
    }
    module.hot.accept("./ActivityStep.vue?vue&type=template&id=05127c6c&scoped=true", function () {
      api.rerender('05127c6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/calendario_venda/components-combo/ActivityStep.vue"
export default component.exports